import * as React from 'react';
import { LinkAction } from '../../model/Action';
import { MachineContext } from '../fsm/useMachine';
import guidGenerator from '../utils/commonFunctions';
import { LinkProps } from './LinkScreen';

export const WebLink: React.FC<LinkProps<LinkAction>> = ({ set_action, existing }) => {
    const [, send] = React.useContext(MachineContext)

    const formAction = (e: React.ChangeEvent<HTMLInputElement>) => {
        send({ type: "MARK_ACTIVE", id: e.currentTarget.id })
        let cuRRL = e.currentTarget.value
        let action = new LinkAction(cuRRL)
        if (!cuRRL.startsWith("https://")) {
            action = new LinkAction(`https://${cuRRL}`)
        }
        set_action({ __tag: "web", value: action })
    }

    return (
        <React.Fragment>
            <div className="linkMenu-desc">
                <h3>Set Web Link</h3>
                <p>Clicking this item will open the address below.</p>
            </div>
            <input
                type="text"
                placeholder={"Enter a Web URL..."}
                defaultValue={existing?.weblink}
                id={guidGenerator()}
                onChange={formAction}
                className="linkInput"
            />
        </React.Fragment>
    )
}